import GlassColor from './glasscolor'

export default class GlassColorCollection {
  public index: number = 0
  public items: GlassColor[] = []
  public selected: boolean = false
}
